import { toast } from "react-toastify";
import { _single } from "../../../../../../../../core/services/dataBean/EntityCatalog";
import { _AttentionPointAgenda } from "../../../../../../../../core/services/dataBean/QuickEntityCatalog";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../../../../modules/theme/Component/PrintJson";
import { Alert } from "../../../../../../../../modules/theme/Component/Alert";
import { useEffect } from "react";
import "./SelectCardAvailableAppointmentDates.css"

interface ComponentData {
    ServiceIDLn: number;
    onChange: Function;
}


export const SelectCardAvailableAppointmentDates = ({ ServiceIDLn, onChange }: ComponentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_AttentionPointAgenda);

    useEffect(() => {
        if (ServiceIDLn) {
            getListaDays();
        }
    }, [ServiceIDLn])


    const getListaDays = () => {
        instance.getAvailableAppointment(_single.getCurrenYear(), _single.getCurrentMonth() + 1, ServiceIDLn).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const functionClick = (item: any) => {
        setBean(item);
        onChange?.(item);
    }

    return (
        <>
            {lista.length > 0 ? (
                <div className="d-flex gap-2 flex-wrap mt-2">
                    {lista.map((item, index) => {
                        const data = item.DataBeanProperties;
                        const isSelected = bean.Date === data.Date;

                        return (
                            <div
                                key={index}
                                className={`p-2 rounded shadow-sm day-card ${isSelected ? "selected" : ""}`}
                                style={{ width: "140px", cursor: "pointer" }}
                                onClick={() => functionClick(data)}
                            >
                                <h6 className="fw-bold mb-1 text-center">{data.DayName}</h6>

                                <p className="text-center mb-1" style={{ fontSize: "0.8rem" }}>
                                    {data.Date}
                                </p>

                                <p className="text-center mb-0" style={{ fontSize: "0.75rem" }}>
                                    <strong>Asesores disponibles:</strong> {data.AttentionPointCount}
                                </p>
                            </div>
                        );
                    })}
                </div>
            ) : (ServiceIDLn ?
                (
                    <Alert clase="info" children="No hay citas disponibles" />
                ) : (
                    <Alert clase="warning" children="Debe seleccionar un servicio" />
                )
            )}
        </>
    )
}